import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import React from 'react';
import { FunctionComponent } from 'react';
import buttonOutlinedStyles from './ButtonOutlinedStyles';

interface IButtonOutlined {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  buttonText: string | JSX.Element;
  className?: string;
  isButtonDisabled?: boolean;
}

const ButtonOutlined: FunctionComponent<IButtonOutlined> = ({
  onClick,
  buttonText,
  className,
  isButtonDisabled,
  ...props
}) => {
  const style = buttonOutlinedStyles();
  return (
    <Button
      onClick={onClick}
      disabled={isButtonDisabled}
      className={clsx([style.root, { [style.disabled]: isButtonDisabled }, className])}
      {...props}
    >
      {buttonText}
    </Button>
  );
};

export default ButtonOutlined;
